import { DataGridHook } from '../controllers/UseDataGridHook';
import EmptyState from './EmptyState';
import LinearProgressIndicator from './LinearProgressIndicator';
import TicketDetailsPopover from './TicketDetailsPopover';
import TicketRow from './TicketRow';

const TicketsDatagrid = (props) => {
  const {
    handleClose,
    handleClick,
    handleNavigate,
    handleChangeUser,
    rows,
    positionX,
    positionY,
    loader,
    dataUsersList,
    open,
    canReassignTicket,
  } = DataGridHook(props);

  const ContainerTable = () => {
    if (rows?.length > 0)
      return (
        <div className={'list-box'}>
          {rows.map((ticket, index) => (
            <TicketRow
              key={index}
              ticket={ticket}
              handleNavigate={handleNavigate}
              handleClick={handleClick}
              canReassignTicket={canReassignTicket}
            />
          ))}
        </div>
      );
    else return <EmptyState />;
  };

  return (
    <div>
      {loader ? <LinearProgressIndicator loader={loader} /> : <ContainerTable />}
      <TicketDetailsPopover
        open={open}
        handleClose={handleClose}
        positionX={positionX}
        positionY={positionY}
        dataUsersList={dataUsersList}
        handleChangeUser={handleChangeUser}
      />
    </div>
  );
};

export default TicketsDatagrid;
